import { BasicCommand } from "./BasicCommand";
import { DependencyRule } from "./DependencyRule";
import { DependencyType } from "./DependencyType";
import { OnDeleteOption } from "./OnDeleteOption";
export class DependencyRuleBuilder<TPrincipal extends BasicCommand<TPrincipal>, TDependent extends BasicCommand<TDependent>> {
    principal: string;
    principalKeySelector: (entity: TPrincipal) => any = null;
    dependent: string;
    dependentKeySelector: (entity: TDependent) => any = null;
    type: DependencyType;
    onDeleteOption: OnDeleteOption = OnDeleteOption.ignore;

    /**
     * @param value Förälder groupkey
     */
    withPrincipal(value: string, keySelector: (entity: TPrincipal) => any = null): DependencyRuleBuilder<TPrincipal, TDependent> {
        this.principal = value;
        this.principalKeySelector = keySelector;
        return this;
    }

    /**
     * @param value Barn groupkey
     */
    withDependent(value: string, keySelector: (entity: TDependent) => any = null): DependencyRuleBuilder<TPrincipal, TDependent> {
        this.dependent = value;
        this.dependentKeySelector = keySelector;
        return this;
    }

    withType(value: DependencyType): DependencyRuleBuilder<TPrincipal, TDependent> {
        this.type = value;
        return this;
    }

    onDelete(value: OnDeleteOption): DependencyRuleBuilder<TPrincipal, TDependent> {
        this.onDeleteOption = value;
        return this;
    }

    build(): DependencyRule {
        return new DependencyRule(this);
    }
}
